import { VCHASNO_PAYMENT_CODES, FiscalOperation } from './prro.types';
import { historyDate } from './fiscal-history.view';

const object = (value: unknown): Record<string, unknown> => value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
const amount = (value: unknown): number | null => typeof value === 'number' && Number.isFinite(value) ? value : null;
const text = (value: unknown): string | null => typeof value === 'string' && value.trim() ? value : null;
const paymentCodes = new Set<number>(VCHASNO_PAYMENT_CODES);
const code = (value: unknown): number | null => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : null;

/** Receipt contents come from the immutable submitted request, not the current deal. */
export function fiscalOperationView(operation: FiscalOperation) {
  const info = object(operation.response?.['info']);
  const fiscal = object(operation.request_snapshot?.['fiscal']);
  const receipt = object(fiscal['receipt']);
  const cash = object(fiscal['cash']);
  const rows = (Array.isArray(receipt['rows']) ? receipt['rows'] : []).map((raw, index) => {
    const row = object(raw);
    const quantity = amount(row['cnt']);
    const price = amount(row['price']);
    const cost = fiscal['subtask'] === 1 ? price : amount(row['cost']) ?? (quantity !== null && price !== null ? quantity * price : null);
    const discount = row['disc'] === undefined ? 0 : amount(row['disc']);
    const total = cost !== null && discount !== null ? Math.round((cost - discount) * 100) / 100 : null;
    return { id: `row-${index}`, name: text(row['name']), quantity, price, discount,
      total: amount(total), taxGroup: code(row['taxgrp']), sku: text(row['code']) };
  });
  const payments = (Array.isArray(receipt['pays']) ? receipt['pays'] : []).map((raw, index) => {
    const pay = object(raw);
    const paymentCode = code(pay['type']);
    return { id: `pay-${index}`, code: paymentCode, name: text(pay['name']), amount: amount(pay['sum']),
      label: paymentCode !== null && paymentCodes.has(paymentCode) ? `prro.payment_methods.${paymentCode}` : 'prro.payment_method',
      custom: paymentCode !== null && !paymentCodes.has(paymentCode) };
  });
  return {
    date: historyDate(info['dt']), number: code(info['docno']),
    cashier: text(info['cashier']) ?? text(fiscal['cashier']),
    offline: typeof info['isoffline'] === 'boolean' ? info['isoffline'] : null,
    cashBalance: amount(info['safe']),
    total: amount(receipt['sum']) ?? amount(cash['sum']), rows, payments,
    phase: fiscal['subtask'] === 1 ? 'advance' : fiscal['subtask'] === 2 ? 'final' : 'sale',
    receipt: operation.task === 1 || operation.task === 2,
  };
}
export type FiscalOperationView = ReturnType<typeof fiscalOperationView>;
